import styled from "styled-components";

export const CustomTitle = styled.h1`
  display: flex;
  align-items: center;
  width: 100%;
  color: #6f6b7d;
  font-family: Roboto;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  padding: 10px;
`;
